module.exports = __webpack_public_path__ + "img/biaozhun-yuangong.ce1b4cc5.svg";